export default "__VITE_ASSET__BirhBkOg__"